import { USER_LOGOUT_CLEAR } from 'constants/ActionTypes';
import * as authTypes from 'modules/auth/actionTypes';
import { LOGIN_STEPS } from 'modules/auth/constant';
import { createReducer } from 'utils/ReduxUtils';

import * as usersTypes from '../../actionTypes';

const initialState = false;

/**
 * Handle load session failure - mark as initialized
 * @returns {boolean}
 */
const handleLoadSessionFailure = () => true;

/**
 * Handle current user data success - mark as initialized
 * @returns {boolean}
 */
const handleCurrentUserDataSuccess = () => true;

/**
 * Handle current user data failure - mark as not initialized
 * @returns {boolean}
 */
const handleCurrentUserDataFailure = () => false;

/**
 * Handle auth step change - mark as initialized on LOGIN step
 * @param {boolean} state
 * @param {import('modules/auth/types').SetAuthStepAction} action
 * @returns {boolean}
 */
const handleSetAuthStep = (state, { type, payload }) => {
  if (type !== authTypes.SET_AUTH_STEP || payload.step === LOGIN_STEPS.LOGIN) {
    return true;
  }
  return state;
};

/**
 * Handle sign out emergency - mark as initialized (to show login page)
 * @returns {boolean}
 */
const handleSignOutEmergency = () => true;

export default createReducer(initialState, {
  [USER_LOGOUT_CLEAR]: () => true,
  [authTypes.SET_AUTH_STEP]: handleSetAuthStep,
  [authTypes.SIGN_OUT_EMERGENCY]: handleSignOutEmergency,
  [authTypes.LOAD_SESSION_FAILURE]: handleLoadSessionFailure,
  [usersTypes.CURRENT_USER_DATA_SUCCESS]: handleCurrentUserDataSuccess,
  [usersTypes.CURRENT_USER_DATA_FAILURE]: handleCurrentUserDataFailure,
});
